import Vue from "vue";
import App from "./App.vue";
import router from "@/router";
import store from "@/store";
import Vant from "vant";
import waterfall from "vue-waterfall2";
import { Lazyload } from "vant";
import "amfe-flexible";
import "@/scripts/pageAdapt";
import "@/scripts/vconsole";
import "@/scripts/iframe";
import "@/scripts/track";
import "normalize.css/normalize.css";
import "vant/lib/index.less";
import "@/assets/styles/vant.less";
import "@/assets/styles/forPc.css";
import "@/assets/styles/fonts.css";
import "@/assets/less/common.less";
import "@vant/touch-emulator";
import { Toast } from "vant";
import { zoom } from "@/directives/zoom";
Vue.directive("zoom", zoom);

Vue.config.ignoredElements = ["wx-open-launch-weapp"];
import { Popover } from "vant";
Vue.use(Vant);
Vue.use(waterfall);
Vue.use(Lazyload);
Vue.use(Popover);
Vue.mixin({
  methods: {
    thenResolve(res) {
      return new Promise((resolve, reject) => {
        const { code, data, msg } = res;
        if (code === 0) {
          resolve(data);
        } else {
          Toast({
            message: msg,
            icon: "warning-o",
          });
          reject(res);
        }
      });
    },
  },
});
Vue.config.productionTip = false;
const vue = new Vue({
  store,
  router,
  render: (h) => h(App),
}).$mount("#app");

export default vue;
